import { DestroyRef, Inject, Injectable, Optional, PLATFORM_ID, TransferState, inject, makeStateKey } from '@angular/core';
import { Router } from '@angular/router';
import { Partner } from '@app/models/partner/IPartner';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { CookiesService } from './cookies.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { PartnerService } from './partner.service';
import { environment } from 'src/environments/environment';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EncryptionService } from './encyption.service';
import { REQUEST } from 'browsertockens';
import { DEFAULT_PARTNER_ID } from '@app/components/tools/Const';

const STATE_KEY_PARTNER = makeStateKey('partnerdata');
@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    protected currentPartnerId: string = null;
    protected currentPartner!: Partner;
    protected contentPartnerSubject: BehaviorSubject<string>;
    protected contentPartnerDataSubject: BehaviorSubject<Partner>;
    protected hidenHeaderFooterSubject: BehaviorSubject<boolean>;

    protected trackingid: string;
    protected sessionid: string;

    isBrowser: boolean = false;
    destroyRef = inject(DestroyRef);
    constructor(
        protected partnerService: PartnerService,
        protected encService: EncryptionService,
        protected router: Router,
        protected auth: AuthService,
        protected cookies: CookiesService,
        protected location: Location,
        protected state: TransferState,
        @Inject(DOCUMENT) protected document: any,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(REQUEST) private request: any,
    ) {
        this.contentPartnerSubject = new BehaviorSubject(null);
        this.hidenHeaderFooterSubject = new BehaviorSubject(false);
        this.contentPartnerDataSubject = new BehaviorSubject({} as Partner);

        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    async checkPartner(id) {
        const cookiid = this.getfromcookisssr('currentPartnerId');
        let target: unknown = {};
        if (id !== cookiid) {
            target = { partnerid: String(id).toLowerCase(), cookipartnerid: cookiid };
        } else {
            target = { partnerid: String(id).toLowerCase() };
        }

        // to get partner stocked in angular state
        const partres = this.state.get(STATE_KEY_PARTNER, <any>{});
        if (partres?.data?.length > 0) {
            // console.log(partres)
            const tokenFromUI = partres.data?.slice(-16);
            const data = partres.data?.slice(0, (partres.data.length - 16));
            this.currentPartner = JSON.parse(this.encService.deencrypt(tokenFromUI, data));
            // console.log(this.currentPartner)
        }
        this.state.set(STATE_KEY_PARTNER, <any>{});

        if (this.currentPartner?.partnerid?.length > 0) {
            this.initPartnerData();
        } else {

            this.partnerService.request(target, 'checkpartner').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe((part) => {
                if (part?.data?.length > 0) {
                    const tokenFromUI = part.data?.slice(-16);
                    const data = part.data?.slice(0, (part.data.length - 16));
                    const res = JSON.parse(this.encService.deencrypt(tokenFromUI, data));
                    if (isPlatformServer(this.platformId)) {
                        this.state.set(STATE_KEY_PARTNER, <any>part);
                        if (res?.partnerid !== DEFAULT_PARTNER_ID) {
                            this.request.res.cookie('currentPartnerId', res?.partnerid, {
                                maxAge: 730 * 24 * 60 * 60 * 1000,
                                path: '/',
                                secure: true,
                                // httpOnly: true,
                                sameSite: 'Lax'
                            });
                        }
                    } else if (res?.partnerid !== DEFAULT_PARTNER_ID) {
                        this.cookies.setCookie('currentPartnerId', res?.partnerid, 730, '/');
                    }
                    if (res?.partnerid?.length > 0) {
                        this.currentPartner = res as Partner;
                        this.initPartnerData();
                    } else {
                        this.router.navigate(['notfound']);
                    }
                    // console.log((Date.now() - start) / 1000);
                } else {
                    this.router.navigate(['notfound']);
                }
            });
        }

    }

    getlogo(): string {
        return this.currentPartner?.logo;
    }

    resetpartnerincookie(id): void {
        if (isPlatformServer(this.platformId) && this.request.headers.cookie) {
            this.request.res.cookie('currentPartnerId', id, {
                maxAge: 730 * 24 * 60 * 60 * 1000,
                path: '/',
                secure: true,
                // httpOnly: true,
                sameSite: 'Lax'
            });
            // console.log(id)
        } else if (this.isBrowser) {
            // console.log(id)
            this.cookies.setCookie('currentPartnerId', id, 730, '/');
        }
        this.currentPartner = null;
        this.checkPartner(id);
    }

    getfromcookisssr(name: string): string {
        if (isPlatformServer(this.platformId) && this.request.headers.cookie) {
            // console.log(this.request.headers.cookie)
            const ca: Array<string> = this.request.headers.cookie.split(';');
            const caLen: number = ca.length;
            const cookieName = `${name}=`;
            let c: string;

            for (let i: number = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');
                if (c.indexOf(cookieName) === 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return DEFAULT_PARTNER_ID;
        } else if (this.isBrowser) {
            // console.log(document.cookie)
            return this.cookies.getCookie(name);
        } else {
            return DEFAULT_PARTNER_ID;
        }
    }

    getrecapchekey(): Promise<string> {
        return new Promise(result => {
            this.getPartner$.pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(partner => {
                if (partner.partnerid?.length > 0) {
                    result(partner.recaptchaSiteKeyV3 || '6Lex5dIrAAAAAKA18BbFm2ZzCnx9tFh9mRn8mEG3');
                } else {
                    result('6Lex5dIrAAAAAKA18BbFm2ZzCnx9tFh9mRn8mEG3')
                }
            });
        });
    }

    initPartnerData(): void {
        this.currentPartnerId = String(this.currentPartner.partnerid).toLowerCase();
        this.contentPartnerDataSubject.next(this.currentPartner);
        this.contentPartnerSubject.next(this.currentPartnerId);
        if (this.isBrowser) {
            window.localStorage.setItem('partnerid', this.currentPartnerId);
            window.localStorage.setItem(this.currentPartnerId + '_use_slash', this.currentPartner.useSlash);
            // console.log(this.currentPartnerId !== DEFAULT_PARTNER_ID);
            // if (this.currentPartnerId !== DEFAULT_PARTNER_ID) {
            //     this.cookies.setCookie('currentPartnerId', this.currentPartnerId, 730, '/');
            // }
            this.auth.isAuthenticated(this.currentPartnerId);
        }
        this.setCustomColors(this.currentPartner);

        for (let i = 0; i < this.currentPartner.agenturen?.length; i++) {
            if (!this.currentPartner.agenturen[i].aktiv) {
                this.currentPartner.agenturen.splice(i, 1);
                i--;
            }
        }
        if (this.isBrowser) {
            if (environment.production) {
                this.checktid();
            }
        }
    }

    protected setCustomColors(part) {
        this.document.body.classList.add(part?.partnerid);
        if (part?.searchpanelbgcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-bg-color', part.searchpanelbgcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-bg-color', '#8e0622');
        }

        if (part?.searchpanelcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-text-color', part.searchpanelcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-text-color', '#fff');
        }

        if (part?.successcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-success-color', part.successcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-success-color', 'rgb(0,130,0)');
        }

        if (part?.successtextcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-success-text-color', part.successtextcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-success-text-color', '#fff');
        }

        if (part?.errorcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-error-color', part.errorcolor);
        }

        if (part?.errortextcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-error-text-color', part.errortextcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-error-text-color', 'rgb(180,30,30)');
        }

        if (part?.searchpanelcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-text-color', part.searchpanelcolor);
        }

        if (part?.bgcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-bgcolor', part?.bgcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-bgcolor', '#ffffff');
        }

        if (part?.pricediscounttextcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-price-discount-text-color', part.pricediscounttextcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-price-discount-text-color', '#fff');
        }

        if (part?.pricediscountbgcolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-price-discount-bg-color', part.pricediscountbgcolor);
        } else {
            this.document.documentElement.style.setProperty('--cl-price-discount-bg-color', '#ff5c5c');
        }

        if (part?.textprimary?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-textprimary', part.textprimary);
        } else {
            this.document.documentElement.style.setProperty('--cl-textprimary', '#545454');
        }

        if (part?.textsecondary?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-textsecondary', part.textsecondary);
        } else {
            this.document.documentElement.style.setProperty('--cl-textsecondary', '#545454');
        }

        if (part?.texta?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-texta', part.texta);
        } else {
            this.document.documentElement.style.setProperty('--cl-texta', '#545454');
        }

        if (part?.textahover?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-textahover', part.textahover);
        }

        if (part?.fontfamily?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-fontfamily', part.fontfamily);
        } else {
            this.document.documentElement.style.setProperty('--cl-fontfamily', '"Helvetica Neue", Helvetica, Arial, sans-serif');
        }

        if (part?.fontsize?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-fontsize', part.fontsize);
        } else {
            this.document.documentElement.style.setProperty('--cl-fontsize', '16px');
        }

        if (part?.margin?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-margin', part.margin);
        } else {
            // this.document.documentElement.style.setProperty('--cl-margin', '0');
        }

        if (part?.fontweight?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-fontweight', part.fontweight);
        } else {
            // this.document.documentElement.style.setProperty('--cl-fontweight', '300');
        }

        if (part?.letterspacing?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-letterspacing', part.letterspacing);
        } else {
            // this.document.documentElement.style.setProperty('--cl-letterspacing', '0.4px');
        }

        if (part?.lineheight?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-lineheight', part.lineheight);
        } else {
            // this.document.documentElement.style.setProperty('--cl-lineheight', '1.4');
        }

        if (part?.placeholdercolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-placeholdercolor', part.placeholdercolor);
        }

        if (part?.linescolor?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-linescolor', part.linescolor);
        }

        if (part?.lineheight?.length > 0) {
            this.document.documentElement.style.setProperty('--cl-lineheight', part.lineheight);
        } else {
            // this.document.documentElement.style.setProperty('--cl-lineheight', '1.4');
        }
        if (part?.extrastyle?.length > 0) {
            const cleverstyle = this.document.getElementById('clever-custom-style');
            if (cleverstyle) {
                cleverstyle.innerText = part.extrastyle.replaceAll('\n', '');
            }
        }
    }

    getPartnerId(): string {
        return String(this.currentPartnerId).toLowerCase();
    }

    getPartnerLicense(): string {
        return this.currentPartner?.traffics?.licence;
    }

    getGiataLicense(): string {
        return this.currentPartner?.giatalicence;
    }

    sethidenHeaderFooterSubject(val): void {
        this.hidenHeaderFooterSubject.next(val);
    }

    get gethidenHeaderFooter$() {
        return this.hidenHeaderFooterSubject.asObservable();
    }

    getPartner(): Partner {
        return this.currentPartner;
    }

    getPartnerTel(): string {
        return this.currentPartner.tel;
    }

    getPartnerCurrency() {
        return this.currentPartner.partnercurrency?.length > 0 ? this.currentPartner.partnercurrency : 'EUR';
    }

    getPeakworkLicence(): string {
        return this.currentPartner?.peakwork?.apikey;
    }

    getPeakwork(): any {
        return this.currentPartner?.peakwork;
    }

    getAmadeus(): any {
        return this.currentPartner?.amadeus;
    }

    getPartnerTraffics(): any {
        return this.currentPartner?.traffics;
    }

    get getPartnerid$() {
        return this.contentPartnerSubject.asObservable();
    }

    get getPartner$() {
        return this.contentPartnerDataSubject.asObservable();
    }

    getPrtBg(): string {
        return this.currentPartner?.searchpanelbgcolor;
    }

    async checktid() {
        this.trackingid = this.cookies.getCookie('CR_' + this.currentPartnerId + '_TID');
        this.partnerService.request({ trackingid: this.trackingid, partnerid: this.currentPartnerId }, 'checktid').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res.trackingid?.length === 24) {
                this.trackingid = res.trackingid;
                this.sessionid = res.sessionid;
                this.cookies.setCookie('CR_' + this.currentPartnerId + '_TID', this.trackingid, 365);
                window.sessionStorage.setItem('CR_' + this.currentPartnerId + '_SID', this.sessionid);
                this.setSessionTrackingurls(this.location.path());
                this.location.onUrlChange(url => this.setSessionTrackingurls(url));
            }
        });
    }

    async setSessionTrackingurls(url) {
        const target = {
            partnerid: this.currentPartnerId,
            trackingid: this.trackingid,
            sessionid: this.sessionid,
            url: url
        };

        this.partnerService.request(target, 'setSessionTrackingurls').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => { });
    }
}
